import styled from 'styled-components'
import { EDirection } from 'types/enums/ELanguage'

export const PassportInputContainer = styled.div<{ direction: EDirection }>`
  direction: ${({ direction }) => direction};
  position: relative;
`

export const ChosenLanguage = styled.div<{ direction: EDirection }>`
  direction: ${({ direction }) => (direction === 'rtl' ? 'ltr' : 'rtl')};
  position: absolute;
  ${({ direction }) => (direction === EDirection.RTL ? 'left' : 'right')}: 0;
  top: 0;
  display: flex;
`

export const OptionsWrapper = styled.div`
  display: flex;
  max-width: 180px;
  overflow: auto;
  border-radius: 50px;
`
